import _taggedTemplateLiteral from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import gql from 'graphql-tag';
export var ReferralCodesQueryGQL = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query ReferralCodesQuery($member_id: Int, $member_type: String) {\n    referral_codes(\n      where: { member_id: { _eq: $member_id }, member_type: { _eq: $member_type }, aasm_state: { _eq: \"enabled\" } }\n    ) {\n      code\n    }\n  }\n"])));